import React from "react";
import EventCreateForm from "../forms/EventCreateForm";
import { Container } from "@airbus/components-react";

class EventCreateView extends React.Component {

    constructor(props){
        super(props);

        //Notification params
        this.setNotification=this.props.notificationHandler;  //call parent notification handler

    }


    /**
    * RENDERING
    */

    render(){

        return(
            <Container>

                <EventCreateForm notificationHandler={this.setNotification} />

            </Container>
        );

    }

}

export default EventCreateView;
